import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import SVG from 'react-inlinesvg'

import LinkHandler from 'components/atoms/LinkHandler'

import { userCheckMobileScreen } from 'helpers/tools'
import './ResponseBlock.scss'

function ResponseBlock({ className, date, linkType, link, preview, title, thumbnail }) {
  const isMobile = userCheckMobileScreen()

  function getExtension(url) {
    const temp = url.split('.')
    return temp[temp.length - 1]
  }

  function BlockImage({ thumbnail }) {
    const extension = getExtension(thumbnail?.src)

    if (linkType === 'download') {
      return <i className="block-result-download-icon icone-download" />
    }
    if (extension === 'svg') {
      return <SVG className="" src={thumbnail.src} />
    }
    return <img alt={thumbnail?.alt} src={thumbnail?.src} />
  }

  return (
    <section className={`ResponseBlock block-result ${className}`}>
      <LinkHandler
        className="d-md-flex align-items-center"
        to={link}
        target={linkType === 'download' ? '_blank' : '_self'}
      >
        <div className="block-result-image d-flex justify-content-center">
          <BlockImage thumbnail={thumbnail} />
        </div>
        <div className="block-result-information">
          <h3 className={`block-result-title ${!isMobile ? ' max-line-1' : ''}`}>{title}</h3>
          <p className={`block-result-preview ${!isMobile ? ' max-line-2' : ' max-line-3'}`}>{preview}</p>
          <p className="block-result-link max-line-1">{link}</p>
          {date && <p className="block-result-date">{date}</p>}
        </div>
      </LinkHandler>
    </section>
  )
}

ResponseBlock.defaultProps = {
  link: '/',
}

ResponseBlock.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  preview: PropTypes.string,
  link: PropTypes.string.isRequired,
  linkType: PropTypes.string,
  thumbnail: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }),
}

export default ResponseBlock
